export default "__VITE_ASSET__7JLupSWm__"